export { default } from './StuiFormattedContent'
